import axios from 'axios';
import authHeader from './auth-header';

const API_URL = `${process.env.REACT_APP_MY_HOST}/admin/kiotviet`;

class KiotVietService {

    /**
     * Lấy danh sách sản phẩm KiotViet
     * @param {string} search - Từ khóa tìm kiếm (tuỳ chọn)
     * @returns {Promise} Danh sách sản phẩm
     */
    getProducts(search = '') {
        let url = `${API_URL}/products`;
        if (search) {
            url += `?search=${encodeURIComponent(search)}`;
        }
        return axios.get(url, { headers: authHeader() }).then(response => {
            return response.data;
        });
    }

    /**
     * Đồng bộ sản phẩm từ KiotViet
     * @returns {Promise} Kết quả đồng bộ
     */
    syncProducts() {
        return axios.post(`${API_URL}/sync-products`, {}, { headers: authHeader() }).then(response => {
            return response.data;
        });
    }

    /**
     * Lấy chi tiết sản phẩm theo ID
     * @param {number} id - ID sản phẩm
     * @returns {Promise} Thông tin sản phẩm
     */
    getProductById(id) {
        return axios.get(`${API_URL}/products/${id}`, { headers: authHeader() }).then(response => {
            return response.data;
        });
    }

    /**
     * Test kết nối KiotViet
     * @returns {Promise} Trạng thái kết nối
     */
    testConnection() {
        return axios.get(`${API_URL}/test-connection`, { headers: authHeader() }).then(response => {
            return response.data;
        });
    }

}

export default new KiotVietService();
